import React from 'react';
import { STATUS_COLORS, defaultT } from './constants.js';

/**
 * StatusBadge — Farb-Badge fuer Tenant-Status.
 * i18n-Key: shared.tenant.status.<status>
 */
export default function StatusBadge({ status, t = defaultT }) {
  const s = STATUS_COLORS[status] || { color: '#9ca3af', bg: '#f3f4f6' };
  return (
    <span style={{
      fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 10,
      color: s.color, background: s.bg, display: 'inline-block', whiteSpace: 'nowrap',
    }}>
      {t(`shared.tenant.status.${status}`, status)}
    </span>
  );
}
